import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { SuggestionRequestWithRequester } from 'types'
import { sendToApi } from 'api/client'

interface Props {
  id: number
}

export const fetchSuggestionRequest = async (id: number) => {
  const res = await sendToApi<{ request: SuggestionRequestWithRequester }>(`/ai_suggestion_requests/${id}`)

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }
  return res.data
}

export const useAISuggestionRequest = (
  { id }: Props,
  options?: UseQueryOptions<{ request: SuggestionRequestWithRequester }>,
) => {
  return useQuery<{ request: SuggestionRequestWithRequester }>(
    ['aiSuggestionRequest', 'detail', id],
    () => fetchSuggestionRequest(id),
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
